<template>
  <div class="Home-area">
    <div class="banner-area">
      <swiper
        class="swiper-container"
        :options="swiperOption"
        ref="swiperBanner"
        v-if="bannerList.length > 0"
      >
        <swiper-slide
          class="banner-slide"
          v-for="(banner, index) in bannerList"
          :key="index"
        >
          <router-link
            :to="{
              name: 'productDetail',
              params: {
                typeid: hrefs[index].product_class_id,
                id: hrefs[index].id
              }
            }"
          >
            <img :src="imgBaseUrl + banner" alt="wan " />
          </router-link>
        </swiper-slide>
      </swiper>
      <div class="sub-nav">
        <ul class="container dis_flex">
          <li class="dis_flex dis_ali dis_jucont">
            <router-link to="/aboutus/qualification" class="dis_flex dis_ali">
              <img src="../assets/06.png" alt="企业荣誉" />
              企业荣誉
            </router-link>
          </li>
          <li class="dis_flex dis_ali dis_jucont">
            <router-link to="/aboutus/culture" class="dis_flex dis_ali">
              <img src="../assets/07.png" alt="万杰文化" />
              万杰文化
            </router-link>
          </li>
          <li class="dis_flex dis_ali dis_jucont">
            <router-link to="/relationship/members" class="dis_flex dis_ali">
              <img src="../assets/08.png" alt="投资者关系" />
              投资者关系
            </router-link>
          </li>
          <li class="dis_flex dis_ali dis_jucont">
            <router-link to="/aboutus/speech" class="dis_flex dis_ali">
              <img src="../assets/09.png" alt="慈善公益" />
              董事长致辞
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div class="abouts-area container">
      <div class="public-lead">
        关于万杰&nbsp;/
        <span>ABOUT US</span>
      </div>
      <div class="dis_flex">
        <div class="video">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
          ></video-player>
        </div>
        <div class="text-intro">
          <div class="en-title">WANJIE INTELLIGENT</div>
          <div class="intro">
            万杰智能科技股份有限公司始创于1996年3月，一直致力于智能主食机械的研发、制造、营销和服务。公司从创立之初就肩负“为亿万消费者主食安全服务”的宗旨，以主食机械智能化发展战略来服务主食...
          </div>
        </div>
      </div>
    </div>
    <div class="product-area ">
      <div class="container">
        <div class="cp_l fl pr">
          <h3><a title="产品分类">产品分类</a></h3>
          <ul class="cp_ul01">
            <li v-for="(product, index) in typeArr" :key="index">
              <router-link
                :to="{
                  path: '/productCenter',
                  query: { typename: product.id }
                }"
                :title="product.name"
                >{{ product.name }}</router-link
              >
            </li>
          </ul>
        </div>
        <div class="cp_r fr">
          <ul>
            <li
              v-for="(product, index) in typeArr"
              :key="index"
              v-if="index < 9"
            >
              <router-link
                :to="{
                  path: '/productCenter',
                  query: { typename: product.id }
                }"
                target="_blank"
                :title="product.name"
              >
                <img
                  :alt="product.name"
                  :src="
                    product.product_class_img +
                      '?x-oss-process=image/resize,h_296,w_296'
                  "
                  :title="product.name"
                />
                <span>{{ product.name }}</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="news-area">
      <div class="container">
        <div class="public-lead">
          新闻动态&nbsp;/
          <span>NEWS</span>
        </div>
        <div class="area news-list dis_flex flex_wrap">
          <router-link
            :to="{
              name: 'NewsDetail',
              params: { type: item.classifyid, id: item.id }
            }"
            class="news-item dis_flex"
            v-for="(item, index) in newsList"
            :key="index"
          >
            <div class="img">
              <img
                :src="
                  item.article_img +
                    '?x-oss-process=image/resize,m_fill,h_114,w_211'
                "
                :alt="item.title"
                onerror="../assets/11.png"
              />
            </div>
            <div class="info">
              <div class="title ellipsis">{{ item.title }}</div>
              <div class="attr dis_flex dis_jucontween">
                <span>{{ item.created_time }}</span>
                <span>浏览次数 {{ item.look_count }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="solution-area ">
      <div class="container">
        <div class="public-lead">
          解决方案&nbsp;/
          <span>SOLUTION</span>
        </div>
        <div class="area">
          <div class="fl solution_l">
            <ul>
              <li
                :class="{ cur: activeAnli == 22 }"
                @mouseover="getNewAnliList(22)"
              >
                <router-link
                  :to="{ name: 'solution', query: { id: 22 } }"
                  title="品牌企业解决方案"
                >
                  品牌企业解决方案
                  <em>Brand enterprise</em>
                </router-link>
              </li>
              <li
                :class="{ cur: activeAnli == 25 }"
                @mouseover="getNewAnliList(25)"
              >
                <router-link
                  :to="{ name: 'solution', query: { id: 25 } }"
                  title="个体工商户解决方案"
                >
                  个体工商户解决方案
                  <em>Individual business</em>
                </router-link>
              </li>
              <li
                :class="{ cur: activeAnli == 24 }"
                @mouseover="getNewAnliList(24)"
              >
                <router-link
                  :to="{ name: 'solution', query: { id: 24 } }"
                  title="专卖连锁解决方案"
                >
                  专卖连锁解决方案
                  <em>Monopoly chain</em>
                </router-link>
              </li>
              <li
                :class="{ cur: activeAnli == 23 }"
                @mouseover="getNewAnliList(23)"
              >
                <router-link
                  :to="{ name: 'solution', query: { id: 23 } }"
                  title="公共食堂解决方案"
                >
                  公共食堂解决方案
                  <em>Public canteen</em>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="fr solution_list">
            <ul>
              <li v-for="(item, index) in anliList" :key="index">
                <router-link
                  :to="{ name: 'solution', query: { id: item.id } }"
                  target="_blank"
                >
                  <img
                    :alt="item.title"
                    :src="item.article_img"
                    :title="item.title"
                  />
                  <p>{{ item.title }}</p>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="clear"></div>
          <!-- <router-link
          :to="{ name: 'solution', query: { id: item.id } }"
          class="item dis_flex"
          v-for="(item, index) in slution"
          :key="index"
        >
          <div class="img">
            <img
              :src="item.article_img"
              :alt="item.title"
              :title="item.title"
            />
          </div>
          <div class="title ellipsis">{{ item.title }}</div>
        </router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import "video.js/dist/video-js.css";
import "../../static/video.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { videoPlayer } from "vue-video-player";
export default {
  data() {
    return {
      videoCnt: {},
      swiperOption: {
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },       
        observeParents: true,
        observer: true
      },
      playerOptions: {
        height: "390",
        muted: false,
        // playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            // mp4
            src: "http://wxsmjphoto.wanjiejixie.com/wjsxy/zmj/00001.mp4"
          }
        ],
        poster: "http://wxsmjphoto.wanjiejixie.com/guanwang/video-poster.png",
        language: "zh-CN",
        fluid: true
      },
      newsList: [],
      bannerList: [],
      slution: [],
      imgBaseUrl: this.$imgBaseUrl,
      hrefs: [
        {
          product_class_id: 13,
          id: 27
        },
        {
          product_class_id: 9,
          id: 22
        },
        {
          product_class_id: 9,
          id: 22
        },
        {
          product_class_id: 13,
          id: 27
        },
        {
          product_class_id: 9,
          id: 22
        }
      ],
      typeArr: [],
      activeAnli: 22,
      anliList: []
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  components: {
    swiper,
    swiperSlide,
    videoPlayer
  },
  mounted() {
    this.getBanner();
    this.getProType();
    this.getNews();
    this.getVideo();
    this.getNewAnliList(22);
    // this.$refs.videoPlayer.player.play()
  },
  methods: {
    getBanner: function() {
      // const _this = this
      this.$https
        .fetchPost("/api/getbanner", {})
        .then(res => {
          this.bannerList = JSON.parse(res.data.data.banner);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getNews: function() {
      this.$https
        .fetchPost("/Article/article_list", {
          classifyid: "15",
          limit: 6,
          is_recommend: 1
        })
        .then(res => {
          // console.log(res.data.data)
          this.newsList = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getVideo: function() {
      this.$https
        .fetchPost("/Article/article_list", {
          classifyid: 16,
          limit: 3
        })
        .then(res => {
          // console.log(res.data)
          this.slution = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProType: function() {
      this.$https
        .fetchPost("/Product/product_class_list", {})
        .then(res => {
          this.typeArr = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getNewAnliList: function(type) {
      this.activeAnli = type;
      this.$https
        .fetchPost("/Article/article_list", {
          // classifyid: "22,23,24,25",
          classifyid: type,
          limit: 6
        })
        .then(response => {
          this.anliList = response.data.data || [];
        });
    }
  }
};
</script>
<style lang="less">
.Home-area {
  .banner-area {
    position: relative;
    .banner-slide {
      cursor: pointer;
      // min-height:
    }
    .sub-nav {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background: rgba(0, 0, 0, 0.2);
      z-index: 10;
      li {
        width: 25%;
        height: 126px;
        cursor: pointer;
        position: relative;
        &:not(:last-child)::after {
          content: "";
          position: absolute;
          top: 50%;
          right: 0;
          margin-top: -32px;
          width: 1px;
          height: 64px;
          background-color: #f5f5f5;
          opacity: 0.5;
        }
        &:hover {
          background-image: linear-gradient(
              90deg,
              rgba(0, 189, 213, 0.3) 0%,
              rgba(44, 242, 204, 0.3) 100%
            ),
            linear-gradient(rgba(1, 183, 184, 0.3), rgba(1, 183, 184, 0.3));
          background-blend-mode: normal, normal;
          box-shadow: 2px 3.5px 8.1px 0.9px rgba(0, 194, 191, 0.46);
        }

        a {
          opacity: 1 !important;
          font-family: MicrosoftYaHei;
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: rgba(255, 255, 255, 1);
        }
        img {
          width: 33px;
          height: 33px;
          margin-right: 7px;
        }
      }
    }
  }
  .public-lead {
    position: relative;
    padding-left: 20px;
    font-family: MicrosoftYaHei-Bold;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 56px;
    letter-spacing: 0px;
    color: #333333;
    margin-bottom: 20px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -12px;
      width: 5px;
      height: 24px;
      background-image: linear-gradient(0deg, #00bdd5 0%, #2cf2cc 100%),
        linear-gradient(#f5f5f5, #f5f5f5);
      background-blend-mode: normal, normal;
      box-shadow: 2px 3.5px 8.1px 0.9px rgba(0, 194, 191, 0.46);
      border-radius: 2px;
    }
    span {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 56px;
      letter-spacing: 0px;
      color: #999999;
    }
  }
  .clear {
    clear: both;
    height: 0;
  }
  .product-area {
    padding: 30px 0 40px;
    background: #fafafa;

    .cp_l {
      float: left;
      position: relative;
      // width: 224px;
      padding: 0 0 15px;
      border: rgb(19, 181, 179) 3px solid;
      background: #fff;
      h3 {
        background: url(~@/assets/cp_ltbg.gif) no-repeat;
        width: 224px;
        height: 85px;
        font-weight: normal;
        a {
          font-size: 26px;
          color: rgba(255, 255, 255, 1);
          display: block;
          padding: 20px 0 0 72px;
        }
      }
      .cp_ul01 {
        li {
          a {
            display: block;
            font-size: 16px;
            color: #333;
            font-weight: bold;
            width: 175px;
            height: 46px;
            line-height: 46px;
            background: #0072bf url(~@/assets/cp_libg.gif) no-repeat;
            margin: 20px auto 0;
            padding: 0 0 0 25px;
            box-sizing: content-box;
            &:hover {
              color: #13b5b3;
            }
          }
        }
        .cp_ul02 {
          padding: 10px 0 0;
          li {
            a {
              display: block;
              font-size: 14px;
              color: #666;
              font-weight: normal;
              margin: 0 auto;
              border-bottom: #d3d3d3 1px dashed;
              height: 32px;
              line-height: 32px;
              background: url(~@/assets/cp_ico02.gif) no-repeat 25px 14px;
              padding: 0 0 0 42px;
              width: 158px;
              overflow: hidden;
              &:hover {
                font-weight: bold;
                color: #006060;
              }
            }
          }
        }
      }
    }

    .cp_r {
      float: right;
      width: 928px;
      li {
        width: 296px;
        float: left;
        position: relative;
        overflow: hidden;
        &:not(:nth-child(3n + 1)) {
          margin: 0 0 0 20px;
        }
        a {
          font-size: 17px;
          color: rgba(102, 102, 102, 1);
          &:hover {
            color: rgb(19, 181, 179);
            font-weight: bold;
          }
        }
        img {
          width: 296px;
          height: 296px;
        }
        span {
          display: block;
          text-align: center;
          height: 50px;
          line-height: 36px;
          overflow: hidden;
        }
      }
    }
  }
  .abouts-area {
    padding: 35px 0 62px;
    .video {
      width: 600px;
      // height: 390px;
      border-radius: 10px;
      overflow: hidden;
    }
    .text-intro {
      flex: 1;
      padding: 45px 78px 0 40px;
      .en-title {
        font-family: Arial-BoldMT;
        font-size: 36px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #c9cbd5;
        margin-bottom: 60px;
      }
      .intro {
        font-family: MicrosoftYaHei;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #303245;
      }
    }
  }
  .news-area {
    // background-color: #fafafa;
    padding: 46px 0 62px;
    .area {
      .news-item {
        box-shadow: 0px 0px 25px 0px rgba(12, 3, 6, 0.1);
        width: 48%;
        background-color: #ffffff;
        border-radius: 5px;
        overflow: hidden;
        margin-bottom: 22px;
        &:nth-child(2n) {
          margin-left: 4%;
        }
        .img {
          width: 211px;
          height: 114px;
          margin-right: 20px;
          border-radius: 5px;
          overflow: hidden;
          img {
            border-radius: 5px;
          }
        }
        .info {
          width: 57%;
          .title {
            font-family: MicrosoftYaHei;
            font-size: 17px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 36px;
            letter-spacing: 0.4px;
            color: #222222;
            padding: 10px 0 15px;
          }
          .attr {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 36px;
            letter-spacing: 0px;
            color: #999999;
          }
        }
      }
    }
  }
  .solution-area {
    background-color: #fafafa;
    padding: 35px 0 80px;
    .area {
      padding-top: 20px;
      .fl {
        float: left;
      }
      .fr {
        float: right;
      }
      .solution_l {
        width: 284px;
        li {
          width: 284px;
          height: 81.5px;
          padding: 0 0 10px;
          // box-sizing: content-box;
          &:not(:last-child) {
            margin-bottom: 24px;
          }
          a {
            font-size: 20px;
            color: #333;
            font-weight: bold;
            display: block;
            height: 64px;
            width: 243px;
            background-color: rgba(255, 255, 255, 1);
            border: solid 2px rgba(19, 181, 179, 1);
            display: block;
            padding: 12px 0 0 35px;
            line-height: 26px;
            box-sizing: content-box;
          }
          em {
            display: block;
            font-size: 14px;
            color: #b7b7b7;
            font-weight: normal;
            font-style: normal;
            font-family: Arial, Helvetica, sans-serif;
          }
        }
        a:hover,
        .cur a {
          background-color: rgba(19, 181, 179, 1);
          color: #fff;
        }
        a:hover em,
        .cur em {
          color: rgba(217, 217, 217, 1);
        }
      }

      .solution_list {
        width: 850px;
        min-height: 450px;
        li {
          display: inline-block;
          margin-bottom: 15px;
          &:not(:nth-child(3n)) {
            margin-right: 35px;
          }
          &:hover {
            p {
              color: rgba(19, 181, 179, 1);
              font-weight: bold;
            }
          }
          img {
            width: 260px;
            height: 170px;
          }
          p {
            height: 38px;
            line-height: 38px;
            font-size: 15px;
            text-align: center;
            color: #333333;
          }
        }
      }
      // .item {
      //   position: relative;
      //   width: 363px;
      //   height: 440px;
      //   background-color: #ffffff;
      //   border-radius: 10px;
      //   overflow: hidden;
      //   .title {
      //     position: absolute;
      //     bottom: 0;
      //     left: 0;
      //     width: 100%;
      //     font-family: MicrosoftYaHei;
      //     font-size: 20px;
      //     font-weight: normal;
      //     font-stretch: normal;
      //     line-height: 69px;
      //     letter-spacing: 0px;
      //     color: #ffffff;
      //     background: rgba(0, 0, 0, 0.7);
      //     padding: 0 10%;
      //     text-align: center;
      //   }
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue